"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_oop_1 = tslib_1.__importDefault(require("vue-oop"));
const plugins_1 = require("./plugins");
const trans_1 = tslib_1.__importDefault(require("./plugins/trans"));
const logger_1 = tslib_1.__importDefault(require("./plugins/logger"));
const core_1 = tslib_1.__importDefault(require("./store/core"));
class CorePlugin extends plugins_1.GenericPlugin {
    constructor() {
        super(...arguments);
        this.pluginName = 'core';
        this.store = core_1.default;
    }
    static beforeInstall(vm, options) {
        vm.use(trans_1.default);
        vm.use(logger_1.default);
        vm.use(vue_oop_1.default, {
            debug: true,
            rest: false,
            graphql: true,
            schema: options.schema,
            schemaUrl: options.schemaUrl,
        });
    }
}
exports.default = CorePlugin;
//# sourceMappingURL=core.plugin.js.map